<template>
  <footer class="footer">
    <div class="footer-container">
      <img class="footer-logo" src="/img/pub/logo-az.png" alt="Logo de AZ Group">
      <div>
        © {{ new Date().getFullYear() }} AgBI – <strong>Una plataforma de AZ Group</strong>
        <br>
        Consultora integral en agronegocios de LATAM  
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style>
.footer{
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-container {
  justify-content: center; 
  display: block;
  text-align: left;
  font-size: 0.9em;
  color: #666;
  padding: 1em 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}
.footer-logo {
  width: 10rem;
  height: auto;
  object-fit: contain;
}
.footer, .footer-container {
  background-color: #ddd;
}
</style>
